
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('appState');

builder.addStatePart('feedback', { lastDisplay: '0' }, null, 'SESSION');

const module = builder.build();

export default module;
